import { render, staticRenderFns } from "./box3.vue?vue&type=template&id=93f70cb6&scoped=true&"
import script from "./box3.vue?vue&type=script&lang=js&"
export * from "./box3.vue?vue&type=script&lang=js&"
import style0 from "./box3.vue?vue&type=style&index=0&id=93f70cb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f70cb6",
  null
  
)

export default component.exports